import React from 'react';
import { VscReport, VscKey, VscSignOut, VscListTree, VscLocation, VscPerson, VscStarEmpty } from 'react-icons/vsc';
import { Link, useHistory } from 'react-router-dom';
import { BiShareAlt } from 'react-icons/bi';
import { ChildrenContainer, NavItems, NavTop, Sidebar } from './style';
import cmcImg from '../../assets/logo.png';

const Layout: React.FC = ({ children }) => {
    const history = useHistory();

    const logout = (): void => {
        sessionStorage.removeItem('token');
        history.push('/');
    };

    return (
        <>
            <Sidebar>
                <NavTop>
                    <Link to="/parametros">
                        <img src={cmcImg} alt="brasão cmc" />
                        <h2>CMC-API</h2>
                    </Link>
                </NavTop>

                <NavItems>
                    <li>
                        <Link to="/chaves">
                            <VscKey size={30} />
                            <span>Chaves</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/relatorios">
                            <VscReport size={30} />
                            <span>Relatórios</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/setores">
                            <VscListTree size={40} color='#0000FF'/>
                            <span>Setores</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/fgs">
                            <VscStarEmpty size={40} color='#0000FF'/>
                            <span>FG´s</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/lotacoes">
                            <VscLocation size={40} color='#0000FF'/>
                            <span>Lotações</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/usuarios">
                            <VscPerson size={40} color='#0000FF'/>
                            <span>Usuários</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/areas">
                            <BiShareAlt size={30} />
                            <span>Áreas</span>
                        </Link>
                    </li>
                    <li>
                        <button onClick={logout} type="button">
                        <VscSignOut size={40} />
                        <p>Logout</p>
                    </button>
                    </li>
                </NavItems>
            </Sidebar>
            <ChildrenContainer>{children}</ChildrenContainer>
        </>
    );
};

export default Layout;
